import { render, staticRenderFns } from "./StaffSelectionTable.vue?vue&type=template&id=0959053a&"
import script from "./StaffSelectionTable.vue?vue&type=script&lang=js&"
export * from "./StaffSelectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0959053a')) {
      api.createRecord('0959053a', component.options)
    } else {
      api.reload('0959053a', component.options)
    }
    module.hot.accept("./StaffSelectionTable.vue?vue&type=template&id=0959053a&", function () {
      api.rerender('0959053a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/StaffSelectionTable.vue"
export default component.exports